import { render, staticRenderFns } from "./AddTransDialog.vue?vue&type=template&id=e97f6546&scoped=true&"
import script from "./AddTransDialog.vue?vue&type=script&lang=js&"
export * from "./AddTransDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddTransDialog.vue?vue&type=style&index=0&id=e97f6546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97f6546",
  null
  
)

export default component.exports